import React from 'react';
import './Section.css';

const Section = ({ name }) => {
  return (
    <h2 className="section">{name}</h2>
  )
}

export default Section;
